import { KTIcon } from '@/_metronic/helpers'
import { FC, useState } from 'react'
import { useFilterReportRushHour } from '../../core/FilterReportRushHourProvider'

type Props = {
  closeModal: () => void
}

const FilterReportRushHourModalHeader: FC<Props> = ({closeModal}) => {
  const {updateFilterReportRushHourFormValue, filterReportRushHourFormValue} =
    useFilterReportRushHour()
  const [filterValueTemp, setFilterValueTemp] = useState(filterReportRushHourFormValue)

  const cancelModal = () => {
    updateFilterReportRushHourFormValue(filterValueTemp)
    closeModal()
  }

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Advanced Filter</h2>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={cancelModal}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export { FilterReportRushHourModalHeader }

